import { sample, throttleOncePer, shouldSendOnce } from './shouldSendOnce'

type EventPayload = Record<string, any> | undefined
type NoopFn = (..._args: any[]) => void

const noop: NoopFn = () => {}

export const buildTrack = () => {
  const event = noop

  return {
    event,

    viewedOnce: (
      name: string,
      entityId: string | number,
      ttlMs: number,
      props?: EventPayload
    ) => {
      if (shouldSendOnce(name, entityId, ttlMs)) event(name, props)
    },

    sampled: (name: string, rate: number, props?: EventPayload) => {
      if (sample(rate)) event(name, props)
    },

    throttled: (name: string, key: string, ms: number, props?: EventPayload) => {
      if (throttleOncePer(key, ms)) event(name, props)
    },

    searched: (
      query: string,
      results: number,
      context: string,
      props?: EventPayload
    ) => {
      const key = `search:${context}:${query.slice(0, 20)}`
      if (throttleOncePer(key, 2000)) {
        // Mantém o formato legado para evitar quebra de contrato
        event('content_searched', {
          ...props,
          query,
          results,
          context
        })
      }
    },

    journey: {
      viewed: noop,
      blocked: noop
    },

    stage: {},

    level: {
      viewed: noop,
      startedOrResumed: noop,
      outOfTime: noop,
      outOfHearts: noop,
      completed: noop,
      blocked: noop
    },

    challenge: {
      started: noop,
      completed: noop
    },

    mission: {
      viewed: noop,
      started: noop,
      completed: noop,
      failed: noop,
      rewardClaimed: noop,
      listInteracted: noop
    },

    document: {
      viewed: noop,
      downloaded: noop,
      submitted: noop,
      signed: noop,
      verified: noop
    }
  }
}
